// assets
import { Story, DollarSquare, Candle, CpuSetting, Calculator, Bank, Chart, RepeatCircle } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  candles: Candle,
  instruments: CpuSetting,
  historicData: Candle,
  calculator: Calculator,
  brokers: Bank,
  widgets: Story,
  prices: DollarSquare,
  marketCharacter: Chart,
  dailyPatternMatch: RepeatCircle
};

const app: NavItemType = {
  id: 'App',
  title: 'App',
  icon: icons.widgets,
  type: 'group',
  children: [

    {
      id: 'brokers',
      title: 'Brokers',
      type: 'item',
      url: '/brokers',
      breadcrumbs: true,
      icon: icons.brokers
    },
    {
      id: 'vealth1st-calcultor',
      title: 'Vealth1st Calculator',
      type: 'item',
      url: '/vealth1st-calculator',
      breadcrumbs: true,
      icon: icons.calculator
    },
    {
      id: 'Instruments',
      title: 'Instruments',
      type: 'item',
      url: '/instruments',
      icon: icons.instruments
    },
    {
      id: 'market-character',
      title: 'Market Character',
      type: 'item',
      url: '/market-character',
      icon: icons.marketCharacter
    },
    {
      id: 'daily-pattern-match',
      title: 'Daily Pattern Match',
      type: 'item',
      url: '/daily-pattern-match',
      icon: icons.dailyPatternMatch
    }
  ]
};

export default app;
